import React, { memo, useCallback, useMemo } from 'react';
import styled from 'styled-components';
import { HourCardDetails } from './hourCardDetails';
import { HourCardWeatherInfo } from './hourCardWeatherInfo';
import { IForecastCard, ToggleMobileHourlyCardDetailsType } from '../../common/types';
import { toggleExpandMobileHourlyCard } from '../../../../common/actions/hourlyForecastPageViewActions';
import { reduxConnect } from '../../../../common';

interface HourCardSmallProps extends IForecastCard {
    cardIndex: number;
    selectedCardsRecord: ToggleMobileHourlyCardDetailsType;
    toggleExpandMobileHourlyCard(expandedCardsRecord: ToggleMobileHourlyCardDetailsType): void;
}

const mapStoreStateToProps = (storeState: any) => {
    const { hourlyForecastPage } = storeState || {};
    const { selectedCardsRecord } = hourlyForecastPage || {};

    return {
        selectedCardsRecord
    };
};

const mapDispatchToProps = {
    toggleExpandMobileHourlyCard
};

export const HourCardSmall = reduxConnect(mapStoreStateToProps, mapDispatchToProps)(memo(({
    selectedCardsRecord = {},
    iconCode, 
    hour, 
    temperature, 
    precipitation, 
    description,
    cardIndex,
    humidity, 
    wind, 
    dewPoint, 
    feelsLike,
    toggleExpandMobileHourlyCard }: HourCardSmallProps) => {

    const handleHourlyCardClick = useCallback(() => {
        const updateSelectedCardsRecord = { ...selectedCardsRecord };
        if (updateSelectedCardsRecord[cardIndex]) {
            updateSelectedCardsRecord[cardIndex] = !selectedCardsRecord[cardIndex];
        } else {
            updateSelectedCardsRecord[cardIndex] = true;
        }
        toggleExpandMobileHourlyCard(updateSelectedCardsRecord);
    }, [cardIndex, selectedCardsRecord]);

    const isExpandedCard = selectedCardsRecord[cardIndex];

    return (
        <Container onClick={handleHourlyCardClick}>
            <HourCardWeatherInfo 
                iconCode={iconCode} 
                hour={hour}
                temperature={temperature} 
                precipitation={precipitation} 
                description={description} />
            {
                isExpandedCard 
                    && <HourCardDetails 
                        humidity={humidity}
                        wind={wind} 
                        dewPoint={dewPoint}
                        feelsLike={feelsLike} />
            }
        </Container>
    );
}));

const Container = styled.li`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: auto;
    margin-bottom: 4px;
    max-height: 116px;
    &:hover {
        cursor: pointer;
    }
`;